import { concantQuery } from "@/utils/concatQuery";
import api from "./api";

/**
 * Get blogs.
 * @param {*} param0
 * @returns
 */
const loadBlogs = ({ take, skip, search }) => {
  const query = concantQuery({ take, skip, search });
  return api.get(`/blogs${query}`);
};

/**
 * Add blog.
 * @param {*} param0
 * @returns
 */
const addBlog = body => {
  return api.post("/blogs", body);
};

/**
 * Add blog.
 * @param {*} param0
 * @returns
 */
const editBlog = (blogId, body) => {
  return api.put(`/blogs/${blogId}`, body);
};

/**
 * Add blog.
 * @param {*} param0
 * @returns
 */
const deleteBlog = blogId => {
  return api.delete(`/blogs/${blogId}`);
};

/**
 * Get blogs.
 * @param {*} param0
 * @returns
 */
const uploadCoverImage = (body) => {
  return api.post('/blogs/uploads', body);
};

export { loadBlogs, addBlog, editBlog, deleteBlog, uploadCoverImage };
